import { FluentMarkdown } from "@bezoned/fluent-markdown";
import { useStableCallback } from "@bezoned/shared/hooks/use-stable-callback.js";
import type { AppChangelogGetResponse } from "@bezoned/shared/types/api/app/app-changelog-get.types.js";
import {
  Button,
  Dialog,
  DialogActions,
  DialogBody,
  DialogContent,
  DialogSurface,
  DialogTitle,
  Image,
} from "@fluentui/react-components";

interface FeaturebaseChangelogDialogProps {
  open: boolean;
  onDismiss: () => void;
  changelog: AppChangelogGetResponse;
}

export const FeaturebaseChangelogDialog = ({
  open,
  onDismiss,
  changelog,
}: FeaturebaseChangelogDialogProps) => {
  const handleOpenChange27 = useStableCallback((_event, data) => {
    if (!data.open) {
      onDismiss();
    }
  });
  const imageUrl = changelog.imageUrl ?? undefined;

  return (
    <Dialog onOpenChange={handleOpenChange27} open={open}>
      <DialogSurface className="sm:max-h-[70vh]">
        <DialogBody className="flex max-h-[70vh] flex-col overflow-hidden p-0">
          <DialogTitle className="m-0">{changelog.title}</DialogTitle>

          <DialogContent className="flex min-h-0 flex-1 flex-col overflow-y-auto px-6 pb-6 sm:px-8 sm:pb-8">
            <div className="flex flex-col gap-6">
              {imageUrl && (
                <div className="overflow-hidden border border-neutral-200/80 bg-slate-50 shadow-[0_18px_50px_rgba(15,23,42,0.08)]">
                  <Image
                    alt={changelog.title}
                    className="h-auto max-h-[520px] w-full object-cover"
                    src={imageUrl}
                  />
                </div>
              )}

              <FluentMarkdown content={changelog.contentMarkdown} />
            </div>
          </DialogContent>

          <DialogActions>
            <Button appearance="primary" onClick={onDismiss}>
              Close
            </Button>
          </DialogActions>
        </DialogBody>
      </DialogSurface>
    </Dialog>
  );
};
